// API service para comunicarse con el backend
const API_BASE_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:5000/api'  // En desarrollo local
  : 'https://felizcumplecamipreciosa.lat/api';  // En producción

export const apiService = {
  // ========== CANCIONES ==========
  async getSongs() {
    try {
      const response = await fetch(`${API_BASE_URL}/songs`);
      return await response.json();
    } catch (error) {
      console.error('Error obteniendo canciones:', error);
      return [];
    }
  },

  async uploadSong(file) {
    try {
      const formData = new FormData();
      formData.append('song', file);

      const response = await fetch(`${API_BASE_URL}/songs/upload`, {
        method: 'POST',
        body: formData,
      });

      return await response.json();
    } catch (error) {
      console.error('Error subiendo canción:', error);
      throw error;
    }
  },

  // ========== ASSETS ==========
  async getAssets(type = 'all') {
    try {
      const response = await fetch(`${API_BASE_URL}/assets/${type}`);
      return await response.json();
    } catch (error) {
      console.error('Error obteniendo assets:', error);
      return [];
    }
  },

  async uploadAsset(file) {
    try {
      const formData = new FormData();
      formData.append('asset', file);

      const response = await fetch(`${API_BASE_URL}/assets/upload`, {
        method: 'POST',
        body: formData,
      });

      return await response.json();
    } catch (error) {
      console.error('Error subiendo asset:', error);
      throw error;
    }
  },

  // ========== PIZARRÓN ==========
  async getPixels() {
    try {
      const response = await fetch(`${API_BASE_URL}/pixels`);
      return await response.json();
    } catch (error) {
      console.error('Error obteniendo píxeles:', error);
      return [];
    }
  },

  async updatePixel(x, y, color) {
    try {
      const response = await fetch(`${API_BASE_URL}/pixels`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ x, y, color }),
      });

      return await response.json();
    } catch (error) {
      console.error('Error actualizando píxel:', error);
      throw error;
    }
  },

  async clearBoard() {
    try {
      const response = await fetch(`${API_BASE_URL}/pixels`, {
        method: 'DELETE',
      });

      return await response.json();
    } catch (error) {
      console.error('Error limpiando pizarrón:', error);
      throw error;
    }
  }
};

// Función legacy para mantener compatibilidad
export const loadAvailableSongs = async () => {
  const songs = await apiService.getSongs();
  const baseUrl = window.location.hostname === 'localhost' 
    ? 'http://localhost:5000'  // En desarrollo local
    : 'https://felizcumplecamipreciosa.lat';  // En producción SIN /api para archivos estáticos
  
  return songs.map(song => ({
    title: song.title,
    src: `${baseUrl}${song.url}`,
    filename: song.filename
  }));
};
